import { Link } from "react-router-dom";
import { LifeBuoy } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2" data-testid="footer-logo">
              <img src="/logo.svg" alt="Serverlistr" width="32" height="32" className="w-8 h-8 rounded-lg" />
              <span className="font-heading font-black text-lg">Serverlistr</span>
            </Link>
            <p className="mt-3 text-sm text-zinc-500 max-w-sm">
              The neon-lit Discord server list & directory. Discover the best Discord servers, or list yours and grow.
            </p>
            <a
              href="https://discord.gg/HWQGPR6nR4"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-support-btn"
              className="mt-4 inline-flex items-center gap-2 h-9 px-3 rounded-lg bg-blurple/10 hover:bg-blurple/20 border border-blurple/40 text-blurple text-xs font-semibold transition-all"
            >
              <LifeBuoy className="w-3.5 h-3.5" />
              Support Discord
            </a>
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 mb-3">Explore</div>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><Link to="/servers" className="hover:text-white">Browse Discord servers</Link></li>
              <li><Link to="/servers?sort=new" className="hover:text-white">New listings</Link></li>
              <li><Link to="/servers/featured" className="hover:text-white">Featured Discord servers</Link></li>
              <li><Link to="/servers?sort=members" className="hover:text-white">Biggest communities</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 mb-3">Categories</div>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li><Link to="/servers/category/gaming" className="hover:text-white">Gaming servers</Link></li>
              <li><Link to="/servers/category/anime" className="hover:text-white">Anime servers</Link></li>
              <li><Link to="/servers/category/community" className="hover:text-white">Community servers</Link></li>
              <li><Link to="/servers/category/programming" className="hover:text-white">Programming servers</Link></li>
              <li><Link to="/servers/category/music" className="hover:text-white">Music servers</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 mb-3">Community</div>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li>
                <a
                  href="https://discord.gg/HWQGPR6nR4"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white"
                  data-testid="footer-community-discord"
                >
                  Discord
                </a>
              </li>
              <li>
                <Link
                  to="/apply"
                  data-testid="footer-staff-apps"
                  className="hover:text-white"
                >
                  Staff Applications
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-white">Partnerships & Featured</Link>
              </li>
              <li>
                <Link
                  to="/status"
                  data-testid="footer-status"
                  className="hover:text-white inline-flex items-center gap-1.5"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                  Status
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} Serverlistr. Not affiliated with Discord Inc.</span>
          <div className="flex items-center gap-4">
            <Link to="/terms" data-testid="footer-terms" className="hover:text-white">Terms</Link>
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-white">Privacy</Link>
            <span className="font-mono">v1.1.0</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
